module.exports = __webpack_public_path__ + "static/media/China12.680d4401.jpg";